import { ISensitiveSettings } from '../../ioc/base/sensitive-settings/sensitive-settings.interface';

export interface ISensitiveSettingsStorage {
    initSettingsStorage(appSettings: ISensitiveSettings, coreSettings: ISensitiveSettings): void;
    initSettings(appSettings: ISensitiveSettings, coreSettings: ISensitiveSettings): Promise<void>;
    resetAllModuleSettingsWithDefaultValues(): Promise<void>;
    loadSettingsFromStorage(): Promise<void>;
}
